import { Injectable } from "@angular/core";
import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import { Observable, map, tap } from "rxjs";
import {
  HandlerBuilder,
  HttpMethod,
} from "@app/core/shared/data/network/base-handler.parameters";
import { TokenAuthorization } from "@app/core/shared/data/network/token-authorization";
import { Booking } from "@app/core/booking/domain/model/booking";
import { BookingMapper } from "@app/core/booking/data/network/booking.mapper";
import { BookingDetail } from "@app/core/booking/domain/model/booking-detail";
import { BookingDetailMapper } from "@app/core/booking/data/network/booking-detail.mapper";

@Injectable({
  providedIn: "root",
})
export class GetBookingWS {
  constructor(private baseHandler: BaseHandler) {}

  execute(bookingId: string, token: string): Observable<Booking> {
    const parameters = new HandlerBuilder()
      .setUrl(ApiUrls.GET_BOOKING_ENDPOINT(bookingId))
      .setMethod(HttpMethod.get)
      .setAuthorization(new TokenAuthorization(token))
      .build();
    return this.baseHandler
      .execute(parameters)
      .pipe(
        map((response) => BookingMapper.deserialize(response))
      );
  }
}
